import React from 'react'
import { Navbar } from 'components/navbar'
import { Footer } from 'components/footer'
import EquitySubmissionForm from 'submission/components/equity-submission/EquitySubmissionForm'

const CreateEquityDeal: React.FC = () => {
  return (
    <div className="flex flex-col min-h-screen bg-neutral-white">
      <Navbar />
      <main className="flex-1 flex flex-col bg-neutral-50">
        <EquitySubmissionForm />
      </main>
      <Footer />
    </div>
  )
}

export default CreateEquityDeal
